'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

module.exports = require('core-js/library/es6/map');


//////////////////
// WEBPACK FOOTER
// ./~/fbjs/lib/Map.js
// module id = 472
// module chunks = 0